import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { CardHeader, Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
const StyledCardHeader = withStyles(theme => createStyles({
  root: props => _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    background: theme.palette.background.header,
    width: 'fill-available',
    alignItems: 'center'
  }, props['data-top'] ? {
    borderRadius: '4px 4px 0 0'
  } : {}), props['data-small'] ? {
    padding: '0 25px 1px'
  } : {
    padding: '0 6px 1px'
  }), props['data-border'] ? {
    borderBottom: `1px solid ${theme.palette.background.paper}`
  } : {}), theme.props.printRules.header),
  title: {
    height: '100%'
  },
  action: {
    alignSelf: 'flex-end',
    marginRight: -3
  },
  avatar: {
    alignSelf: 'flex-end',
    marginTop: -9,
    marginRight: -8
  }
}))(CardHeader);
const HeaderTitle = withStyles(() => createStyles({
  root: {
    position: 'relative',
    padding: '0 8px',
    lineHeight: 'normal',
    height: 'auto' // fontSize: '1.3rem',

  }
}))(Typography);
export const SectionHeader = (_ref) => {
  let {
    title,
    action,
    nav,
    top,
    border,
    TypographyProps,
    small
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "action", "nav", "top", "border", "TypographyProps", "small"]);

  return /*#__PURE__*/React.createElement(StyledCardHeader, _extends({
    action: nav,
    avatar: action,
    "data-top": top,
    "data-border": border,
    "data-small": small,
    title: /*#__PURE__*/React.createElement(HeaderTitle, _extends({
      variant: small ? 'subtitle1' : 'h6',
      color: "primary"
    }, TypographyProps), title)
  }, props));
};